<!DOCTYPE html>
<html lang="es">
  <head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
  </head>
  <body>
    <header id="headContent">
          <span class="header-title">
            {{ 'global.config' | translate }}
          </span>
      <div class="header-controls">
        <div class="action-icon" (click)="toggleSound()">
          <mat-icon *ngIf="isSoundEnabled()">volume_up</mat-icon>
          <mat-icon *ngIf="!isSoundEnabled()">volume_off</mat-icon>
        </div>
        <button class="action-button yellow-button" (click)="save()">
          <span class="button-text">{{ 'global.back' | translate }}</span>
        </button>
      </div>
    </header>

    <main>
      <div class="desks-container">
        <h1 class="content_center">
          {{ 'admin.desks' | translate }}
        </h1>
        <div class="list">
          <div class="item" *ngFor="let desk of desks">
            <div class="item-header">
                  <span class="item-header-identifier">
                    {{ desk.name }}
                  </span>
            </div>
            <div class="turn-item-body">
              <button *ngIf="!desk.active" class="action-button green-button" (click)="enableDesk(desk)">
                <span class="button-text">{{ 'global.enable' | translate }}</span>
              </button>
              <button *ngIf="desk.active" class="action-button red-button" (click)="disableDesk(desk)">
                <span class="button-text">{{ 'global.disable' | translate }}</span>
              </button>
              <button *ngIf="desk.active" class="action-button green-button" (click)="setSelectedDesk(desk)">
                <span class="button-text">{{ 'global.select' | translate }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="locations-container">
        <h1 class="content_center">
          {{ 'admin.locations' | translate }}
        </h1>
        <div class="list">
          <div class="item" *ngFor="let location of locations">
            <div class="item-header">
                <span class="item-header-identifier">
                  {{ location.name }} {{ location.numeration }}
                </span>
            </div>
            <div class="turn-item-body">
              <button class="action-button green-button" (click)="setSelectedLocation(location)">
                <span class="button-text">{{ 'global.select' | translate }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </main>

    <footer id="footer" class="content_left">
      Power by <img src="/assets/images/mturn_logo.svg" class="footer-logo" alt="mTurn Logo">
    </footer>
    <div class="header-langs">
      <div *ngFor="let lang of langList" (click)="changeLang(lang)">
        <button (click)="changeLang(lang)">
          <img class="lang-icon" [src]="lang.icon">
        </button>
      </div>
    </div>
  </body>
</html>
